<template>
  <div>
    <router-view />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import ChooseDesk from '@/components/modals/ChooseDesk'

export default {
  props: {
    serviceID: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'availableServices'
    ]),
    ...mapState([
      'service',
      'loggedUser',
      'currentTickets'
    ])
  },
  created () {
    // console.log(this.availableServices)
    this.fetchProfile()
    this.fetchCurrentTickets(this.serviceID)
    this.fetchService(this.serviceID)
  },
  methods: {
    ...mapActions([
      'fetchProfile',
      'fetchService',
      'fetchCurrentTickets'
    ]),
    openChooseDeskModal (props) {
      this.$showModal('ChooseDesk', ChooseDesk, props)
    }
  }
}
</script>
